import { render } from "./transactions-table.vue?vue&type=template&id=27f3f8e8&scoped=true&ts=true"
import script from "./transactions-table.vue?vue&type=script&lang=ts"
export * from "./transactions-table.vue?vue&type=script&lang=ts"

import "./transactions-table.vue?vue&type=style&index=0&id=27f3f8e8&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f3f8e8"]])

export default __exports__